/**
 * Formatierung, die das Design System (noch) nicht hat.
 *
 * Beträge und Daten laufen über die Formatierer aus @elbklar/ui:
 * `formatEuro(x)` (ganze Euro, Kacheln und Achsen), `formatEuro(x, { cent: true })`
 * (vollständiger Betrag), `formatDatum`, `formatDatumZeit`, `formatVor`.
 *
 * Monate und Achsen ebenso: `formatMonat` (auch `{ kurz: true }`) und
 * `formatEuroAchse`.
 */

/**
 * Runway in Worten.
 *
 * `null` heisst nicht "keine Runway", sondern "reicht ueber den Horizont
 * hinaus" — das ist die gute Nachricht und muss auch so klingen.
 */
export function runwayText(
  monate: number | null,
  horizontUeberschritten: boolean,
  horizont = 24
): string {
  if (monate === null) {
    return horizontUeberschritten ? `> ${horizont} Monate` : '–';
  }
  if (monate === 0) return 'aufgebraucht';
  if (monate === 1) return '1 Monat';
  return `${monate} Monate`;
}

/** Prozentanteil, z. B. "42 %". */
export function prozent(anteil: string | number): string {
  return `${Math.round(Number(anteil) * 100)} %`;
}

/**
 * Heute als YYYY-MM-DD (für Datumsfelder), nach lokaler Zeit. `toISOString`
 * rechnet in UTC und gab bis Oktober 2026 zwischen Mitternacht und ein bzw.
 * zwei Uhr das Datum von gestern.
 */
export function heuteIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
